import React from 'react';
import type { WaiterOrder } from '../types/waiter';

const statusColors: Record<string, string> = {
  pending: 'border-yellow-500/30 bg-yellow-500/5',
  cooking: 'border-orange-500/30 bg-orange-500/5',
  ready: 'border-blue-500/30 bg-blue-500/5',
  served: 'border-emerald-500/30 bg-emerald-500/5',
  paid: 'border-slate-500/30 bg-slate-500/5',
};

const statusLabels: Record<string, string> = {
  pending: 'Ожидает',
  cooking: 'Готовится',
  ready: 'Готов',
  served: 'Подан',
  paid: 'Оплачен',
};

const statusDots: Record<string, string> = {
  pending: 'bg-yellow-400',
  cooking: 'bg-orange-400',
  ready: 'bg-blue-400 animate-pulse',
  served: 'bg-emerald-400',
  paid: 'bg-slate-400',
};

interface Props {
  order: WaiterOrder;
  onClick: () => void;
}

export const WaiterOrderCard: React.FC<Props> = ({ order, onClick }) => {
  const time = new Date(order.createdAt).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  const itemCount = order.items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <button
      onClick={onClick}
      className={`w-full text-left p-4 rounded-xl border transition-all hover:scale-[1.01] ${statusColors[order.status]}`}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          <span className={`w-2.5 h-2.5 rounded-full ${statusDots[order.status]}`} />
          <span className="text-white font-semibold">Стол {order.tableNumber}</span>
        </div>
        <span className="text-slate-400 text-sm">{time}</span>
      </div>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-slate-300 text-sm">{order.client.name}</p>
          <p className="text-slate-500 text-xs">{itemCount} {itemCount === 1 ? 'позиция' : itemCount < 5 ? 'позиции' : 'позиций'}</p>
        </div>
        <div className="text-right">
          <p className="text-emerald-400 font-bold">{order.total} ₽</p>
          <p className="text-slate-500 text-xs">{statusLabels[order.status]}</p>
        </div>
      </div>
    </button>
  );
};
